export { default as component } from "../../../../src/routes/[prefix]/(feature)/memo/+page.svelte";